import { inject } from 'vue';
import { NOTIFY_KEY, defaultNotify, type NotifyFn } from '@/lib/notify';

export default function useNotify(): { notify: NotifyFn } {
  const injected = inject(NOTIFY_KEY, defaultNotify);
  return { notify: injected };
}
